var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('confirm-third-party-modal',{attrs:{"show":true},on:{"confirm":_vm.handleProfileConfirmation,"cancel":_vm.handleCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }